import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CategoryFacetCard from './CategoryFacetCard.vue';
import CategoryLinkCard from './CategoryLinkCard.vue';
import { CatalogState } from 'JS/catalog/store/store';
import { computed, ComputedRef, ref } from 'vue';
import { ISelectedFacetValue } from 'JS/types/Search';
import { useBreakpoints } from 'JS/composables/breakpoint';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCarouselApp',
  setup(__props) {

const minCardsToDisplay = 4;

const store = useLegacyVuexStore<CatalogState>();
const { isDesktop } = useBreakpoints();

const sidebarCategories = computed(() => store.state.categories);

const subcatFacet = computed(() => store.state.facets.find(f => f.field === 'subcat_id'));
const subcatFacetValues = computed(() => {
	const facet = store.state.facets.find(f => f.field === "subcat_id");
	if (facet != null && facet.facetType !== 'nestedcheckbox') {
		return facet.values;
	}
	return [];
});
const selectedFacets: ComputedRef<ISelectedFacetValue[]> = computed(() => store.getters.selectedFacets);
const categoryImages = computed(() => store.state.searchResult.categoryImages ?? {});

const showCarousel = computed(() => {
	return store.getters.showProducts && // on a product lists page
		!store.state.isLoadingSearchResult && // not loading
		selectedFacets.value?.length === 0 && // no facets selected
											  //TODO: Consider removal/update so that subcat_id facet can show when
											  //other facets are selected. Layout shift considerations will need to be addressed,
											  //and may be possible by also removing the "not loading" condition above.
		(!isDesktop.value || (subcatFacetValues.value.length >= minCardsToDisplay || sidebarCategories.value.length >= minCardsToDisplay)); // always show on smaller screens / minimum # of cards on desktop
});
const queryString = computed(() => store.getters.queryString);

const skipBefore = ref<HTMLElement | null>(null);
const skipAfter = ref<HTMLElement | null>(null);

function skipToAfter() {
	if (skipAfter.value) {
		skipAfter.value.focus();
	}
}

function skipToBefore() {
	if (skipBefore.value) {
		skipBefore.value.focus();
	}
}

return { __sfc: true,minCardsToDisplay, store, isDesktop, sidebarCategories, subcatFacet, subcatFacetValues, selectedFacets, categoryImages, showCarousel, queryString, skipBefore, skipAfter, skipToAfter, skipToBefore, CarouselArrowButton, CategoryFacetCard, CategoryLinkCard }
}

})